import {
    FETCH_RAINPRO_PRODUCTS,
    CLEAN_RAINPRO_PRODUCTS,
    DELETE_RAINPRO_PRODUCT,
    CHANGE_RAINPRO_PRODUCT_STATUS,
    CHANGE_RAINPRO_PRODUCTS_STATUS,
    DELETE_RAINPRO_PRODUCTS,
} from '../actions/types';
import _ from "lodash";
import {toNumber} from "../functions";

const RAINPRO_PRODUCTS_DEFAULT_STATE = {};

const RainproProductsReducer = (state = RAINPRO_PRODUCTS_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_RAINPRO_PRODUCTS:
            return payload;

        case CHANGE_RAINPRO_PRODUCT_STATUS:
            return { ...state, items: _.map(state.items, item => {
                if (toNumber(item.id) === toNumber(payload.id)) {
                    item = { ...item, status: payload.status };
                }

                return item;
            }) };

        case CHANGE_RAINPRO_PRODUCTS_STATUS:
        case CLEAN_RAINPRO_PRODUCTS:
        case DELETE_RAINPRO_PRODUCT:
        case DELETE_RAINPRO_PRODUCTS:
            return RAINPRO_PRODUCTS_DEFAULT_STATE;

        default:
            return state;
    }
};

export default RainproProductsReducer;
